module.exports = __webpack_public_path__ + "static/media/bombbanner.8d44d860.png";